import { StorageAdapter } from '../storage-adapter';

import { CookieService } from 'ngx-cookie-service';

export class CookiesAdapter implements StorageAdapter {
  constructor(private cookieService: CookieService) {}

  setAll(object: Record<string, any>) {
    const cookies = Object.keys(object) as Array<keyof object>;

    cookies.forEach(name => {
      if (object[name]) {
        this.cookieService.set(name, object[name]);
      }
    });
  }

  deleteAll(): void {
    this.cookieService.deleteAll();
  }

  getAll<T>(): T {
    return this.cookieService.getAll() as T;
  }

  setItem(name: string, values: string, expiration?: number | Date, path?: string) {
    this.cookieService.set(name, values, expiration, path);
  }

  removeItem(name: string, path?: string) {
    this.cookieService.delete(name, path);
  }

  getItem(name: string) {
    return this.cookieService.get(name);
  }
}
